

export const COOKIES_FLAG = 'fl'
export const FLAG_PREGAME_SURVEY_DONE = 1;
export const FLAG_ENDGAME_SURVEY_DONE = 2;